const navigatorWithDefaultValues = {
  languages: [],
  userAgent: '',
  userLanguage: '',
};

export const isoNavigator =
  typeof navigator === 'undefined' ? navigatorWithDefaultValues : navigator;
